import { makeStyles } from "@mui/styles"

export const useStyles = makeStyles({
  items: {
    width: "30px",
    height: "30px",
    marginRight: "20px",
  },
  textField: {
    width: '50%'
  },
  textArea: {
    margin: "1rem",
  },
  button: {
    width: "100px",
  },
});
